















































import { Component, Prop, Vue } from 'vue-property-decorator';

import * as def from '@/definitions'
import { Const } from '@/const'
// TODO document2
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { PlainTextLayer } from '@/model/document2/page/surface/design/layer/plainTextLayer';
import { TextInfo } from '@/utilityModels/textInfo';
import { UnitHelper } from '@/helper/unitHelper';
import { MathHelper } from '@/helper/mathHelper';
import { UuidHelper } from '@/helper/uuidHelper';
import { StringHelper } from '@/helper/stringHelper';
import { UserAgentHelper } from '@/helper/userAgentHelper';
import { FontManager } from '@/model/fontManager/fontManager';
import { DebugHelper } from "@/helper/debugHelper";

import { Rectangle } from '@/utilityModels/rectangle';

// テキストサイズの計測結果を保持する
const dpTextSize = {};

interface TextLineSize {
    lineWidth: number;
    lineHeight: number;
    lineSpaceWidth: number;
    lineSpaceHeight: number;
}

@Component({
    components: {
    },
})
export default class PlainTextLayerDrawer extends Vue
{
    private get isMobile() { return UserAgentHelper.isMobile(); }

    // プレースホルダー
    static readonly PLACEHOLDER_OPACITY = 0.5;
    // 文字の高さに対する下線の割合
    static readonly UNDERLINE_HEIGHT_FROM_CHARACTER_HEIGHT = 1 / 22.0;
    // 文字の高さに対する下線までのスペース
    static readonly UNDERLINE_SPACING_FROM_CHARACTER_HEIGHT = 4 / 22.0;

    // 最小フォントサイズ(pt)
    static readonly MIN_FONT_SIZE = 1;
    static readonly MAX_FONT_SIZE = 720;

    // 最終自動サイズ
    private lastAutoFontSize = 0;

    @Prop() private layer!: PlainTextLayer;
    @Prop() private scale!: number;
    @Prop() private offsetX!: number;
    @Prop() private offsetY!: number;
    @Prop() private isRendering!: boolean;
    // 直接印刷ではクライアントで処理するのでサーバー用のフォントになると困る
    @Prop({ default: false }) private isRenderingOnClient!: boolean;
    // エディット対象かどうか？
    // 編集面選択に表示されている場合は、キャレットとプレースホルダを表示しないため
    @Prop({ default: false }) private isInEditor! : boolean;

    // レイヤー移動・拡大縮小中の描画省略判定
    @Prop({ default: 0 }) private useSimpleText! : number;
    @Prop({ default: 0 }) private moveLayerMode! : number;
    @Prop({ default: "" }) private moveLayerId! : string;

    // マウント済みフラグ
    private ismounted = false;
    mounted()
    {
        this.ismounted = true;
    }

    private get isVisibleBySystem()
    {
        // シンプルテキストモードが2で、移動・拡大縮小
        if(this.useSimpleText == 2 && this.moveLayerMode > 0 && this.layer.id == this.moveLayerId)
        { return false; }
        // エディット対象以外かつ、文字列が空
        if(!this.isInEditor && this.layer.text == "") return false;
        return true;
    }

    // 不透明度(0 ~ 1.0)
    private get opacity()
    {
        var value = this.layer.opacity / 100;
        if(this.isPlaceholderVisible) { value *= PlainTextLayerDrawer.PLACEHOLDER_OPACITY; }
        if(value < 0) { value = 0; }
        if(value > 1) { value = 1; }
        return value;
    }

    // プレースホルダー
    private get isPlaceholderVisible()
    {
        // マウント前は表示しない
        if(!this.ismounted) { return false; }
        // 編集中は表示しない
        if(this.layer.inEdit) { return false; }
        // レンダリング中は表示しない
        if(this.isRendering) { return false; }
        // エディット対象でなければ表示しない
        if(!this.isInEditor) { return false; }
        // 印刷は表示しない
        var path = this.$router.currentRoute.path;
        if(path == "/PrintSetting") { return false; }
        // レイアウトは表示しない
        if(path == "/LayoutEditor") { return false; }
        // 文字列が空なら表示
        return this.layer.text == "";
    }

    // 文字情報配列
    private get characterInfoArray() : Array<{
        character : string,             // 文字
        lineIndex : number,             // 行index
        characterIndex : number,        // 文字index
        textInfo : TextInfo,            // 文法情報
        x : number,                     // x座標(view)
        y : number,                     // y座標(view)
        width : number,                 // 幅(view)
        height : number,                // 高さ(view)
        fontSize : number,              // フォントサイズ(view)
        letterWidth : number,           // 文字幅(%)
        renderLineIndex : number,       // レンダリングされた行index
        renderCharacterIndex : number,  // レンダリングされた文字index
        uuid : string,                  // UUID
        boundsBefore : Rectangle,       // 文字ポジション判定領域(前)
        boundsAfter : Rectangle         // 文字ポジション判定領域(後)
    }>
    {
        // const t0 = performance.now();

        // テキスト方向により返す情報配列を振り分ける
        var array = this.layer.textOrientation == 1 ? this.characterInfoArrayVertical : this.characterInfoArrayHorizontal;

        // レイヤーの領域情報更新
        // 直接プロパティを変えるとレスポンシブになるので、setter
        var rect = this.getTextPositionAreaFromCharacterInfoArray(array);
        this.layer.updateTextPostionArea(rect.x, rect.y, rect.width, rect.height);

        // DebugHelper.trace("text", this.layer.autoNewLine, performance.now() - t0);

        return array;
    }

    // 文字情報配列から、文字の描画領域をrectで取得する
    private getTextPositionAreaFromCharacterInfoArray(array)
    {
        var minX = 0;
        var minY = 0;
        var maxX = 0;
        var maxY = 0;
        for(var i = 0; i < array.length; ++i)
        {
            var item = array[i];
            var left = Math.min(item.boundsBefore.x, item.boundsAfter.x);
            var top = Math.min(item.boundsBefore.y, item.boundsAfter.y);
            var right = Math.max(item.boundsBefore.x + item.boundsBefore.width, item.boundsAfter.x + item.boundsAfter.width);
            var bottom = Math.max(item.boundsBefore.y + item.boundsBefore.height, item.boundsAfter.y + item.boundsAfter.height);
            minX = i == 0 ? left : Math.min(minX, left);
            minY = i == 0 ? top : Math.min(minY, top);
            maxX = i == 0 ? right : Math.max(maxX, right);
            maxY = i == 0 ? bottom : Math.max(maxY, bottom);
        }
        // mmに戻す
        var x = (minX - this.offsetX) / this.scale;
        var y = (minY - this.offsetY) / this.scale;
        var width = (maxX - minX) / this.scale;
        var height = (maxY - minY) / this.scale;
        return new Rectangle(x, y, width, height);
    }

    // 横書き
    private get characterInfoArrayHorizontal() : Array<{
        character : string,             // 文字
        lineIndex : number,             // 行index
        characterIndex : number,        // 文字index
        textInfo : TextInfo,            // 文法情報
        x : number,                     // x座標(view)
        y : number,                     // y座標(view)
        width : number,                 // 幅(view)
        height : number,                // 高さ(view)
        fontSize : number,              // フォントサイズ(view)
        letterWidth : number,           // 文字幅(%)
        renderLineIndex : number,       // レンダリングされた行index
        renderCharacterIndex : number,  // レンダリングされた文字index
        uuid : string,                  // UUID
        boundsBefore : Rectangle,       // 文字ポジション判定領域(前)
        boundsAfter : Rectangle         // 文字ポジション判定領域(後)
    }>
    {
        // マウント前はテキストサイズが計算できないので空を返す
        if(!this.ismounted) { return []; }
        // シンプルテキストモードが2で、移動・拡大縮小
        if(this.useSimpleText == 2 && this.moveLayerMode > 0 && this.layer.id == this.moveLayerId)
        { return []; }

        if(this.layer.autoSize && !this.layer.inEdit && this.moveLayerMode == 0)
        {
            if (this.layer.savedFontSize > 0) {
                // 計算済みの場合はそのサイズで処理する
                return this.finishHorizontal(this.layer.savedFontSize);
            }

            const fontSize = this.getHorizontalFontSize();
            // フォントサイズ決定
            this.layer.savedFontSize = fontSize;
            return this.finishHorizontal(fontSize);
        }

        // 編集中や固定サイズの場合は強制的に折り返し
        return this.getCharacterInfoArrayHorizontal(true, false);
    }

    // 自動サイズ横書きの仕上げ
    private finishHorizontal(fontSize) {
        // 自動折り返しが有効なら設定しないと編集中にガタガタする
        this.lastAutoFontSize = fontSize;
        if (fontSize === PlainTextLayerDrawer.MIN_FONT_SIZE) {
            // 最小サイズの場合は強制的に折り返し
            return this.getCharacterInfoArrayHorizontal(true, true, PlainTextLayerDrawer.MIN_FONT_SIZE);
        }
        return this.getCharacterInfoArrayHorizontal(this.layer.autoNewLine, true, fontSize);
    }

    // 横書きのフォントサイズを得る
    private getHorizontalFontSize(): number {
        // FIXME 最小サイズ、折り返しがないサイズの場合も枝切りできる
        if (this.layer.autoNewLine) {
            return this.getHorizontalFontSizeWithAutoWrap();
        } else {
            return this.getHorizontalFontSizeWithoutAutoWrap();
        }
    }

    // 折り返し込みでテキストエリアに収まる最大のフォントサイズを得る
    private getHorizontalFontSizeWithAutoWrap(): number {
        // 自動サイズ設定する
        var tryFontSize = 1;
        var tryBeforeFontSize = 1;
        var step = 20;
        while(true)
        {
            // 仮に配置してみる
            const array = this.getCharacterInfoArrayHorizontal(this.layer.autoNewLine, true, tryFontSize);
            // 文字群の幅・高さを求める
            var minX = 0;
            var minY = 0;
            var maxX = 0;
            var maxY = 0;
            for(var i = 0; i < array.length; ++i)
            {
                var info = array[i];
                if(i == 0 || info.x < minX) { minX = info.x; }
                if(i == 0 || info.y < minY) { minY = info.y; }
                if(i == 0 || info.x + info.width > maxX) { maxX = info.x + info.width; }
                if(i == 0 || info.y + info.height > maxY) { maxY = info.y + info.height; }
            }
            var totalWidth = maxX - minX;
            var totalHeight = maxY - minY;

            // 誤差吸収
            totalWidth = Math.floor(totalWidth);
            totalHeight = Math.floor(totalHeight);
            if(totalWidth > this.layer.width * this.scale || totalHeight > this.layer.height * this.scale)
            {
                // レイヤー領域を超えてしまったので、フォントサイズを再設定する
                if(step == 20) { step = 10; }
                else if(step == 10) { step = 5; }
                else if(step == 5) { step = 2; }
                else if(step == 2) { step = 1; }
                else if(step == 1) { step = 0.3; }
                else if(step == 0.3) { step = 0.1; }
                else
                {
                    // 以前のサイズで決定する
                    break;
                }

                // 以前のサイズにstepを加えて再チャレンジする
                tryFontSize = tryBeforeFontSize + step;
            }
            else
            {
                // レイヤー領域を超えない。stepを加えてもう一度計測する
                tryBeforeFontSize = tryFontSize;
                tryFontSize += step;
            }

            if(tryFontSize <= 0)
            {
                tryFontSize = PlainTextLayerDrawer.MIN_FONT_SIZE;
                break;
            }

            if(tryFontSize >= PlainTextLayerDrawer.MAX_FONT_SIZE)
            {
                tryFontSize = PlainTextLayerDrawer.MAX_FONT_SIZE;
                tryBeforeFontSize = tryFontSize;
                break;
            }
        }
        return tryBeforeFontSize;
    }

    // 折り返しなしでテキストエリアに収まる最大のフォントサイズを得る
    private getHorizontalFontSizeWithoutAutoWrap(): number {
        const minFontSize = PlainTextLayerDrawer.MIN_FONT_SIZE;
        const maxFontSize = PlainTextLayerDrawer.MAX_FONT_SIZE;
        // FIXME なんか精度が低いので2周して無理やり精度を上げてる
        const firstFontSize = this.adjustHorizontalFontSize(minFontSize, maxFontSize);
        const fontSize = this.adjustHorizontalFontSize(minFontSize, firstFontSize);
        return fontSize;
    }

    // FIXME 微妙に大きくなる
    // 最適なサイズを測る
    private adjustHorizontalFontSize(minFontSize, maxFontSize): number {
        const sizes = this.measureHorizontalTextSize(maxFontSize);
        if (sizes.length < 1) return PlainTextLayerDrawer.MIN_FONT_SIZE;

        let maxWidthLineIndex = 0;
        let totalLineHeight = 0;
        for (let i = 0; i < sizes.length; i++) {
            const { lineWidth, lineHeight, lineSpaceWidth } = sizes[i];
            // 字間の影響でずれることがあるかも
            if (lineWidth + lineSpaceWidth > sizes[maxWidthLineIndex].lineWidth + sizes[maxWidthLineIndex].lineSpaceWidth) {
                maxWidthLineIndex = i;
            }
            totalLineHeight += lineHeight;
            if (i > 0) {
                // 一つ前の行間を反映する
                totalLineHeight += sizes[i-1].lineSpaceHeight;
            }
        }

        // まずは横幅を比べて縮小する
        const textWidth = sizes[maxWidthLineIndex].lineWidth;
        const areaWidth = (this.layer.width * this.scale) - sizes[maxWidthLineIndex].lineSpaceWidth;
        const fontScaleX = (textWidth > 0 && textWidth > areaWidth) ? (areaWidth / textWidth) : 1.0;
        // さらに縦幅を比べて縮小する
        const textHeight = totalLineHeight * fontScaleX;
        const areaHeight = this.layer.height * this.scale;
        const fontScaleY = (textHeight > 0 && textHeight > areaHeight) ? (areaHeight / textHeight) : 1.0;
        // 最終的な最大フォントサイズとの比
        const fontScale = fontScaleX * fontScaleY;

        // FIXME どっかスケールの計算が違って精度が出ない
        const fontSize = maxFontSize * fontScale;
        return (minFontSize > fontSize) ? minFontSize : fontSize;
    }

    private letterSpaceHorizontalForNoWrap(info): number {
        if (this.layer.horizontalAlignment === 3) {
            // 均等揃えの時は字間の設定を無視する
            return 0;
        }
        return UnitHelper.convert(info.textInfo.letterSpacing, "pt", "mm") * this.scale;
    }

    // 高速化のため自動折り返しを考慮しないで、行ごとのサイズを一気に測る
    private measureHorizontalTextSize(fontSize: number): TextLineSize[] {
        const fontManager = this.$store.getters.fontManager;
        const lines = this.layer.textAll(this.isPlaceholderVisible);
        const lineHeightRatio = this.layer.lineSpacing / 100.0; // %

        // 最初の文字で
        const baseInfo = this.layer.getCharacterInfo(0, 0, this.isPlaceholderVisible);
        if (!baseInfo) return [];

        const l: TextLineSize[] = [];
        for (let li = 0; li < lines.length; li++) {
            const line = lines[li];
            const fontSizeMM = UnitHelper.convert(fontSize, "pt", "mm") * this.scale;
            if (line.length < 1) {
                // 空行の場合は8を計算する
                const size = this.calcTextSize("8", fontSizeMM, baseInfo.textInfo.fontId, false, false, false);
                const letterWidthRatio = baseInfo.textInfo.letterWidth / 100.0; // %
                const lineWidth = 0.1;
                const lineHeight = size.height;
                const lineSpaceWidth = 0;
                const lineSpaceHeight = size.height * (lineHeightRatio - 1.0);
                l.push({ lineWidth, lineHeight, lineSpaceWidth, lineSpaceHeight });
                continue;
            }
            let lineWidth = 0;
            let lineHeight = 0
            let lineSpaceWidth = 0;
            let lineSpaceHeight = 0;

            for (let ci = 0; ci < line.length; ci++) {
                const info = line[ci];
                const letter = info.character;
                const halfWidth = StringHelper.isHankaku(letter);
                const size = this.calcTextSize(letter, fontSizeMM, info.textInfo.fontId, info.textInfo.bold, info.textInfo.italic, false);
                const letterWidthRatio = info.textInfo.letterWidth / 100.0; // %

                lineWidth += size.width * letterWidthRatio;
                if (ci !== line.length - 1) {
                    const letterSpace = this.letterSpaceHorizontalForNoWrap(info);
                    lineSpaceWidth += letterSpace
                }
                if (size.height > lineHeight) {
                    lineHeight = size.height;
                    lineSpaceHeight = size.height * (lineHeightRatio - 1.0);
                }
            }
            l.push({ lineWidth, lineHeight, lineSpaceWidth, lineSpaceHeight });
        }
        return l;
    }

    // まとめて測ると文字ごとの設定を参照できない
    // 高速化のため自動折り返しを考慮しないで、行ごとのサイズを一気に測る
    // private measureHorizontalTextSize(fontSize: number): TextLineSize[] {
    //     const fontManager = this.$store.getters.fontManager;
    //     const text = this.isPlaceholderVisible ? PlainTextLayer.PLACEHOLDER : this.layer.textAll;
    //     const lines = text.split(/\r?\n/g);
    //     const info = this.layer.getCharacterInfo(0, 0, this.isPlaceholderVisible); // 最初の文字を元にする
    //     if (!info) {
    //         return [];
    //     }
    //     const letterSpace = this.letterSpaceHorizontalForNoWrap(info);
    //     const letterWidthRatio = info.textInfo.letterWidth / 100.0; // %
    //     const lineHeightRatio = this.layer.lineSpacing / 100.0; // %

    //     const l: TextLineSize[] = [];
    //     for (let i = 0; i < lines.length; i++) {
    //         const line = lines[i];
    //         const fontSizeMM = UnitHelper.convert(fontSize, "pt", "mm") * this.scale;
    //         if (line.length > 0) {
    //             const halfWidth = StringHelper.isHankaku(line);
    //             const size = this.calcTextSize(line, fontSizeMM, info.textInfo.fontId, info.textInfo.bold, info.textInfo.italic && fontManager.canItalic(info.textInfo.fontId, halfWidth), false);
    //             const lineWidth = size.width * letterWidthRatio;
    //             const lineHeight = size.height;
    //             const lineSpaceWidth = letterSpace * (line.length - 1);
    //             const lineSpaceHeight = size.height * (lineHeightRatio - 1.0);
    //             l.push({ lineWidth, lineHeight, lineSpaceWidth, lineSpaceHeight });
    //         } else {
    //             // 空行の場合は8を計算する
    //             const size = this.calcTextSize("8", fontSizeMM, info.textInfo.fontId, false, false, false);
    //             const lineWidth = size.width * letterWidthRatio;
    //             const lineHeight = size.height;
    //             const lineSpaceWidth = 0;
    //             const lineSpaceHeight = size.height * (lineHeightRatio - 1.0);
    //             l.push({ lineWidth, lineHeight, lineSpaceWidth, lineSpaceHeight });
    //         }
    //     }
    //     return l;
    // }

    // 横書き配置
    // isAutoNewLine : 自動改行する falseの場合はレイヤーの文字列での改行以外で改行しない
    // isSameFontSize : すべて同じフォントサイズを使用する
    // fontSize : 同じフォントサイズを使用する場合のフォントサイズ(pt)
    private getCharacterInfoArrayHorizontal(isAutoNewLine = true, isSameFontSize = false, fontSize = 1) : Array<{
        character : string,             // 文字
        lineIndex : number,             // 行index
        characterIndex : number,        // 文字index
        textInfo : TextInfo,            // 文法情報
        x : number,                     // x座標(view)
        y : number,                     // y座標(view)
        width : number,                 // 幅(view)
        height : number,                // 高さ(view)
        fontSize : number,              // フォントサイズ(view)
        letterWidth : number,           // 文字幅(%)
        renderLineIndex : number,       // レンダリングされた行index
        renderCharacterIndex : number,  // レンダリングされた文字index
        uuid : string,                  // UUID
        boundsBefore : Rectangle,       // 文字ポジション判定領域(前)
        boundsAfter : Rectangle         // 文字ポジション判定領域(後)
    }>
    {
        var array = new Array();

        // マウント前はテキストサイズが計算できないので空を返す
        if(!this.ismounted) { return array; }
        // シンプルテキストモードが2で、移動・拡大縮小
        if(this.useSimpleText == 2 && this.moveLayerMode > 0 && this.layer.id == this.moveLayerId)
        { return new Array(); }

        // フォントマネージャー
        var fontManager : FontManager = this.$store.getters.fontManager;

        // 共通フォントサイズをビューのサイズに変更
        var scaledSameFontSize = UnitHelper.convert(fontSize, "pt", "mm") * this.scale;

        // スタート位置
        var x = this.layer.x * this.scale + this.offsetX;
        var y = this.layer.y * this.scale + this.offsetY;
        var maxHeight = 0;
        // 各行における最大高さの保持用
        var maxHeightArray : Array<number> = new Array();
        var numberInLine = 0;
        var renderLineIndex = 0;
        var renderCharacterIndex = 0;
        for(var lineIndex = 0; lineIndex < this.layer.getLineCount(this.isPlaceholderVisible); ++lineIndex)
        {
            var characterCount = this.layer.getCharacterCount(lineIndex, this.isPlaceholderVisible);
            var characterCountWithPrefixSuffix = characterCount;
            // この行の文字数
            // Placeholderではない、かつ最初の行であれば語頭追加
            var isPrefixContained = !this.isPlaceholderVisible && lineIndex == 0;
            if(isPrefixContained) { characterCountWithPrefixSuffix += this.layer.getPrefixCount(); }
            // Placeholderではない、かつ最後の行であれば語尾追加
            var isSuffixContained = !this.isPlaceholderVisible && lineIndex == this.layer.getLineCount(false) - 1;
            if(isSuffixContained) { characterCountWithPrefixSuffix += this.layer.getSuffixCount(); }

            if(characterCountWithPrefixSuffix == 0)
            {
                // 改行しか存在しない行
                var info = this.layer.getCharacterInfo(lineIndex, 0, this.isPlaceholderVisible);
                if(info != null)
                {
                    // "8"のサイズを測る
                    var tempFontSize = this.layer.autoSize && this.lastAutoFontSize > 0 ? this.lastAutoFontSize : info.textInfo.fontSize;
                    var scaledFontSize = isSameFontSize ? scaledSameFontSize : UnitHelper.convert(tempFontSize, "pt", "mm") * this.scale;
                    var size = this.calcTextSize("8", scaledFontSize, info.textInfo.fontId);
                    // この高さだけ送る
                    y += size.height;
                    array.push({
                        character : "",
                        lineIndex : lineIndex,
                        characterIndex : 0,
                        textInfo : info.textInfo,
                        x : x,
                        y : y,
                        width : 0.1,
                        height : size.height,
                        fontSize : scaledFontSize,
                        letterWidth : info.textInfo.letterWidth,
                        renderLineIndex : renderLineIndex,
                        renderCharacterIndex : 0,
                        uuid : UuidHelper.getUuid(),
                        boundsBefore : new Rectangle(),
                        boundsAfter : new Rectangle()
                    });
                    y += size.height * (this.layer.lineSpacing - 100) / 100;
                    maxHeightArray.push(size.height);
                    renderLineIndex++;
                }
            }
            else
            {
                for(var totalCharacterIndex = 0; totalCharacterIndex < characterCountWithPrefixSuffix; ++totalCharacterIndex)
                {
                    var info : { character : string, index : number, textInfo : TextInfo } | null = null;
                    var characterIndex = -1;
                    if(isPrefixContained && totalCharacterIndex < this.layer.getPrefixCount())
                    {
                        info = this.layer.getPrefixCharacterInfo(totalCharacterIndex);
                    }
                    else if(isSuffixContained && totalCharacterIndex >= characterCountWithPrefixSuffix - this.layer.getSuffixCount())
                    {
                        info = this.layer.getSuffixCharacterInfo(totalCharacterIndex - (characterCountWithPrefixSuffix - this.layer.getSuffixCount()));
                    }
                    else
                    {
                        characterIndex = isPrefixContained ? totalCharacterIndex - this.layer.getPrefixCount() : totalCharacterIndex;
                        info = this.layer.getCharacterInfo(lineIndex, characterIndex, this.isPlaceholderVisible);
                    }

                    if(info != null)
                    {
                        // この文字の大きさを測る
                        var tempFontSize = this.layer.autoSize && this.lastAutoFontSize > 0 ? this.lastAutoFontSize : info.textInfo.fontSize;
                        var scaledFontSize = isSameFontSize ? scaledSameFontSize : UnitHelper.convert(tempFontSize, "pt", "mm") * this.scale;
                        var isHankaku = StringHelper.isHankaku(info.character);
                        var size = this.calcTextSize(info.character, scaledFontSize, info.textInfo.fontId, info.textInfo.bold, info.textInfo.italic, false);
                        // 幅をこの文字の設定に変更
                        size.width *= info.textInfo.letterWidth / 100;
                        if(isAutoNewLine)
                        {
                            if(x + size.width > this.layer.x * this.scale + this.offsetX + this.layer.width * this.scale)
                            {
                                // 描画位置が枠を超えてしまうので改行
                                // 改行前に同じ行にいる文字のy座標を下方向にずらす ... 描画指定位置が左下になるため
                                for(var i = 0; i < numberInLine; ++i)
                                {
                                    var arrayIndex = array.length - 1 - i;
                                    if(arrayIndex >= 0)
                                    {
                                        array[arrayIndex].y += maxHeight;
                                    }
                                }
                                // 行間に従って送る
                                y += maxHeight * this.layer.lineSpacing / 100;
                                x = this.layer.x * this.scale + this.offsetX;
                                maxHeightArray.push(maxHeight);
                                renderLineIndex++;
                                maxHeight = 0;
                                numberInLine = 0;
                                renderCharacterIndex = 0;
                            }
                        }

                        array.push({
                            character : info.character,
                            lineIndex : lineIndex,
                            characterIndex : characterIndex,
                            textInfo : info.textInfo,
                            x : x,
                            y : y,
                            width : size.width,
                            height : size.height,
                            fontSize : scaledFontSize,
                            letterWidth : info.textInfo.letterWidth,
                            renderLineIndex : renderLineIndex,
                            renderCharacterIndex : renderCharacterIndex,
                            uuid : UuidHelper.getUuid(),
                            bounds : new Rectangle(),
                            boundsAfter : new Rectangle()
                        });
                        // 文字送り
                        x += size.width;
                        if(this.layer.horizontalAlignment != 3)
                        {
                            // 文字間を空ける *水平方向均等以外
                            var dx = UnitHelper.convert(info.textInfo.letterSpacing, "pt", "mm") * this.scale;
                            x += dx;
                            array[array.length - 1].bounds.width += dx;
                        }
                        numberInLine++;
                        renderCharacterIndex++;
                        // 最大高さ更新
                        maxHeight = Math.max(maxHeight, size.height);
                    }
                }
            }
            // 改行
            // 改行前に同じ行にいる文字のy座標を下方向にずらす ... 描画指定位置が左下になるため
            for(var i = 0; i < numberInLine; ++i)
            {
                var arrayIndex = array.length - 1 - i;
                if(arrayIndex >= 0)
                {
                    array[arrayIndex].y += maxHeight;
                }
            }
            // 行間に従って送る
            y += maxHeight * this.layer.lineSpacing / 100;
            x = this.layer.x * this.scale + this.offsetX;
            maxHeightArray.push(maxHeight);
            renderLineIndex++;
            maxHeight = 0;
            numberInLine = 0;
            renderCharacterIndex = 0;
        }

        // 水平方向位置
        if(this.layer.horizontalAlignment != 0)
        {
            // 左揃え以外
            var tempArray = new Array();
            for(var i = 0; i < array.length; ++i)
            {
                var item = array[i];

                // 一時配列にアイテムを加える
                tempArray.push(item);

                // 行の最後かどうかしらべる
                var isLastInLine = false;
                if(i == array.length - 1)
                {
                    // 最後のアイテム
                    isLastInLine = true;
                }
                else
                {
                    // 次のアイテムの行番号が異なる
                    isLastInLine = item.renderLineIndex != array[i + 1].renderLineIndex;
                }

                if(isLastInLine)
                {
                    // 行の最後なら水平揃えをする
                    // 行の長さ = (行最後のアイテムのx座標 + 幅) - (行最初のアイテムのx座標)
                    var lineWidth = tempArray[tempArray.length - 1].x + tempArray[tempArray.length - 1].width - tempArray[0].x;

                    if(this.layer.horizontalAlignment == 1 || this.layer.horizontalAlignment == 2)
                    {
                        // 中央/右揃えは同じ値だけx座標をずらす
                        var dx = 0;
                        if(this.layer.horizontalAlignment == 1)
                        {
                            // 中央揃え (レイヤーの幅 - 行の長さ) / 2
                            dx = (this.layer.width * this.scale - lineWidth) / 2;
                        }
                        else if(this.layer.horizontalAlignment == 2)
                        {
                            // 右揃え レイヤーの幅 - 行の長さ
                            dx = this.layer.width * this.scale - lineWidth;
                        }
                        for(var tempItem of tempArray)
                        {
                            tempItem.x += dx;
                        }
                    }
                    else if(this.layer.horizontalAlignment == 3)
                    {
                        // 均等揃えは字間を再設定する
                        // 文字数をカウントする。ただし半角英数記号は並びあっている限りは一文字扱いする
                        // "abc "で1文字
                        var textCount = 0;
                        for(var t = 0; t < tempArray.length; ++t)
                        {
                            var item = tempArray[t];
                            if(item.character.match(/^[\x20-\x7e]*$/) != null && item.character != " ")
                            {
                                // 半角英数記号にマッチング
                                // 末尾 or 次の文字が半角英数記号以外なら文字としてカウント
                                if(t == tempArray.length - 1 || (t < tempArray.length - 1 && !(tempArray[t + 1].character.match(/^[\x20-\x7e]*$/) != null && tempArray[t + 1].character != " ")))
                                {
                                    textCount++;
                                }
                            }
                            else if(item.character == " ")
                            {
                                // 半角スペースにマッチング
                                // 最初 or 直前の文字が半角英数記号以外なら文字としてカウント
                                if(t == 0 || (t > 1 && !(tempArray[t - 1].character.match(/^[\x20-\x7e]*$/) != null && tempArray[t - 1].character != " ")))
                                {
                                    textCount++;
                                }
                            }
                            else
                            {
                                // 文字カウント
                                textCount++;
                            }
                        }

                        if(textCount > 1)
                        {
                            // 2文字以上のみ均等割を行う
                            var spacing = (this.layer.width * this.scale - lineWidth) / (textCount - 1);
                            // 字間は0以上に補正
                            if(spacing < 0) { spacing = 0; }
                            // 字間を設定していく
                            var dx = 0;
                            for(var t = 0; t < tempArray.length; ++t)
                            {
                                var item = tempArray[t];
                                item.x += dx;

                                if(item.character.match(/^[\x20-\x7e]*$/) != null && item.character != " ")
                                {
                                    // 半角英数記号にマッチング
                                    if(t < tempArray.length - 1 && tempArray[t + 1].character.match(/^[\x20-\x7e]*$/) == null)
                                    {
                                        // 次の文字が半角英数記号以外
                                        dx += spacing;
                                    }
                                }
                                else
                                {
                                    dx += spacing;
                                }
                            }
                        }
                    }

                    // 一時配列クリア
                    tempArray = new Array();
                }
            }
        }

        // 垂直方向位置
        if(this.layer.verticalAlignment != 0)
        {
            // 上揃え以外
            // 全文字の一番上の座標・一番下の座標を求める
            var minY = 0;
            var maxY = 0;
            for(var i = 0; i < array.length; ++i)
            {
                var item = array[i];
                if(i == 0 || item.y < minY) { minY = item.y; }
                if(i == 0 || item.y + item.height > maxY) { maxY = item.y + item.height; }
            }
            // 文字全体の高さ
            var allHeight = maxY - minY;
            // 同じ値だけy座標をずらす
            var dy = 0;
            if(this.layer.verticalAlignment == 1)
            {
                // 中央揃え (レイヤーの高さ - 文字全体の高さ) / 2;
                dy = (this.layer.height * this.scale - allHeight) / 2;
            }
            else if(this.layer.verticalAlignment == 2)
            {
                // 下揃え (レイヤーの高さ - 文字全体の高さ)
                dy = this.layer.height * this.scale - allHeight;
            }
            for(var item of array)
            {
                item.y += dy;
            }
        }

        // 判定領域設定
        for(var i = 0; i < array.length; ++i)
        {
            // 行の最後か?
            var isLastInLine = i == array.length - 1 ? true : array[i].renderLineIndex != array[i + 1].renderLineIndex;
            // 最終行か?
            var isLastLine = array[i].renderLineIndex == array[array.length - 1].renderLineIndex;
            // 所属行の最大高さ
            var maxHeight = maxHeightArray[array[i].renderLineIndex];

            var bounds = new Rectangle();

            // x座標は最初の文字なら左端、それ以外は文字の左端
            bounds.x = array[i].renderCharacterIndex == 0 ? this.layer.x * this.scale + this.offsetX : array[i].x;
            // y座標は最初の行なら上端、それ以外は文字の上端
            bounds.y = array[i].renderLineIndex == 0 ? this.layer.y * this.scale + this.offsetY : array[i].y - maxHeight;
            // 幅は次の文字のx座標からx座標を引いた値 ただし最終文字の場合はレイヤーの右端から引く、最初の文字の場合はレイヤーの左端を引く
            bounds.width = (isLastInLine ? this.layer.x * this.scale + this.offsetX + this.layer.width * this.scale : array[i + 1].x) - bounds.x;
            // 高さ
            if(array[i].renderLineIndex == 0 && isLastLine)
            {
                // 最初の行かつ最後の行の場合はレイヤー高さ
                bounds.height = this.layer.height * this.scale;
            }
            else if(array[i].renderLineIndex == 0)
            {
                // 最初の行の場合はyまでの距離に最大高さを足す
                bounds.height = Math.max((bounds.y - (this.layer.y * this.scale + this.offsetY)) + maxHeight * this.layer.lineSpacing / 100, maxHeight * this.layer.lineSpacing / 100);
            }
            else if(isLastLine)
            {
                // 最終行の場合はレイヤーの下端までの距離
                bounds.height = Math.max(this.layer.y * this.scale + this.offsetY + this.layer.height * this.scale - bounds.y, maxHeight * this.layer.lineSpacing / 100);
            }
            else
            {
                // それ以外は最大高さ
                bounds.height = maxHeight * this.layer.lineSpacing / 100;
            }

            // 幅は最低限文字幅分を確保
            if(bounds.width < array[i].width) { bounds.width = array[i].width; }
            // 高さは最低限文字高さ分を確保
            if(bounds.height < array[i].height) { bounds.height = array[i].height; }

            // 設定
            var beforeWidth = Math.max((array[i].x + array[i].width / 2) - bounds.x, 0);
            var afterWidth = Math.max(bounds.width - beforeWidth, 0);
            array[i].boundsBefore = new Rectangle(bounds.x, bounds.y, beforeWidth, bounds.height);
            array[i].boundsAfter = new Rectangle(bounds.x + beforeWidth, bounds.y, afterWidth, bounds.height);
        }

        return array;
    }

    // 自動サイズ縦書きの仕上げ
    private finishVertical(fontSize) {
        // 自動折り返しが有効なら設定しないと編集中にガタガタする
        this.lastAutoFontSize = fontSize;
        if (fontSize === PlainTextLayerDrawer.MIN_FONT_SIZE) {
            // 最小サイズの場合は強制的に折り返し
            return this.getCharacterInfoArrayVertical(true, true, fontSize, true);
        }
        return this.getCharacterInfoArrayVertical(this.layer.autoNewLine, true, fontSize, true);
    }

    // 縦書き
    private get characterInfoArrayVertical() : Array<{
        character : string,             // 文字
        lineIndex : number,             // 行index
        characterIndex : number,        // 文字index
        textInfo : TextInfo,            // 文法情報
        x : number,                     // x座標(view)
        y : number,                     // y座標(view)
        width : number,                 // 幅(view)
        height : number,                // 高さ(view)
        fontSize : number,              // フォントサイズ(view)
        letterWidth : number,           // 文字幅(%)
        renderLineIndex : number,       // レンダリングされた行index
        renderCharacterIndex : number,  // レンダリングされた文字index
        uuid : string,                  // UUID
        boundsBefore : Rectangle,       // 文字ポジション判定領域(前)
        boundsAfter : Rectangle         // 文字ポジション判定領域(後)
    }>
    {
        var array = new Array();

        // マウント前はテキストサイズが計算できないので空を返す
        if(!this.ismounted) { return array; }

        if(this.layer.autoSize && !this.layer.inEdit && this.moveLayerMode == 0)
        {
            if (this.layer.savedFontSize > 0) {
                // 計算済みの場合はそのサイズで処理する
                return this.finishVertical(this.layer.savedFontSize);
            }

            // 自動サイズ設定する
            var tryFontSize = 1;
            var tryBeforeFontSize = 1;
            var step = 20;
            while(true)
            {
                // 仮に配置してみる
                array = this.getCharacterInfoArrayVertical(this.layer.autoNewLine, true, tryFontSize);
                // 文字群の幅・高さを求める
                var minX = 0;
                var minY = 0;
                var maxX = 0;
                var maxY = 0;
                for(var i = 0; i < array.length; ++i)
                {
                    var info = array[i];
                    if(i == 0 || info.x < minX) { minX = info.x; }
                    if(i == 0 || info.y < minY) { minY = info.y; }
                    if(i == 0 || info.x + info.width > maxX) { maxX = info.x + info.width; }
                    if(i == 0 || info.y + info.height > maxY) { maxY = info.y + info.height; }
                }
                var totalWidth = maxX - minX;
                var totalHeight = maxY - minY;

                // 誤差吸収
                totalWidth = Math.floor(totalWidth);
                totalHeight = Math.floor(totalHeight);
                if(totalWidth > this.layer.width * this.scale || totalHeight > this.layer.height * this.scale)
                {
                    // レイヤー領域を超えてしまったので、フォントサイズを再設定する
                    if(step == 20) { step = 10; }
                    else if(step == 10) { step = 5; }
                    else if(step == 5) { step = 2; }
                    else if(step == 2) { step = 1; }
                    else if(step == 1) { step = 0.3; }
                    else if(step == 0.3) { step = 0.1; }
                    else
                    {
                        // 以前のサイズで決定する
                        break;
                    }

                    // 以前のサイズにstepを加えて再チャレンジする
                    tryFontSize = tryBeforeFontSize + step;
                }
                else
                {
                    // レイヤー領域を超えない。stepを加えてもう一度計測する
                    tryBeforeFontSize = tryFontSize;
                    tryFontSize += step;
                }

                if(tryFontSize <= 0)
                {
                    tryFontSize = PlainTextLayerDrawer.MIN_FONT_SIZE;
                    break;
                }

                if(tryFontSize >= PlainTextLayerDrawer.MAX_FONT_SIZE)
                {
                    tryFontSize = PlainTextLayerDrawer.MAX_FONT_SIZE;
                    tryBeforeFontSize = tryFontSize;
                    break;
                }
            }

            // フォントサイズ決定
            this.layer.savedFontSize = tryBeforeFontSize;
            array = this.finishVertical(tryBeforeFontSize);
        }
        else
        {
            array = this.getCharacterInfoArrayVertical(true, false, 1, true);
        }

        return array;
    }

    // FIXME 仕上げの時だけthis.lastAutoFontSizeに依存している. lastAutoFontSizeを設定しないとなぜか他のオブジェクトがガクガクする.
    // 縦書き配置
    // isAutoNewLine : 自動改行する falseの場合はレイヤーの文字列での改行以外で改行しない
    // isSameFontSize : すべて同じフォントサイズを使用する
    // fontSize : 同じフォントサイズを使用する場合のフォントサイズ(pt)
    // isSizeFixed : サイズが決定した
    private getCharacterInfoArrayVertical(isAutoNewLine = true, isSameFontSize = false, fontSize = 1, isSizeFixed = false) : Array<{
        character : string,             // 文字
        lineIndex : number,             // 行index
        characterIndex : number,        // 文字index
        textInfo : TextInfo,            // 文法情報
        x : number,                     // x座標(view)
        y : number,                     // y座標(view)
        width : number,                 // 幅(view)
        height : number,                // 高さ(view)
        fontSize : number,              // フォントサイズ(view)
        letterWidth : number,           // 文字幅(%)
        renderLineIndex : number,       // レンダリングされた行index
        renderCharacterIndex : number,  // レンダリングされた文字index
        uuid : string,                  // UUID
        boundsBefore : Rectangle,       // 文字ポジション判定領域(前)
        boundsAfter : Rectangle         // 文字ポジション判定領域(後)
    }>
    {
        var array = new Array();

        // マウント前はテキストサイズが計算できないので空を返す
        if(!this.ismounted) { return array; }

        // フォントマネージャー
        var fontManager : FontManager = this.$store.getters.fontManager;

        // 共通フォントサイズをビューのサイズに変更
        var scaledSameFontSize = UnitHelper.convert(fontSize, "pt", "mm") * this.scale;

        // スタート位置
        var x = (this.layer.x + this.layer.width) * this.scale + this.offsetX;
        var y = this.layer.y * this.scale + this.offsetY;
        var maxWidth = 0;
        var numberInLine = 0;
        var renderLineIndex = 0;
        var renderCharacterIndex = 0;
        // 縦中横での最大高さ
        var maxHeight = 0;
        // 横幅の最大値の配列
        var maxWidthArray : Array<number> = new Array();
        // 縦中横で描画した幅
        var horizontalWidth = 0;
        for(var lineIndex = 0; lineIndex < this.layer.getLineCount(this.isPlaceholderVisible); ++lineIndex)
        {
            var characterCount = this.layer.getCharacterCount(lineIndex, this.isPlaceholderVisible);
            var characterCountWithPrefixSuffix = characterCount;
            // この行の文字数
            // Placeholderではない、かつ最初の行であれば語頭追加
            var isPrefixContained = !this.isPlaceholderVisible && lineIndex == 0;
            if(isPrefixContained) { characterCountWithPrefixSuffix += this.layer.getPrefixCount(); }
            // Placeholderではない、かつ最後の行であれば語尾追加
            var isSuffixContained = !this.isPlaceholderVisible && lineIndex == this.layer.getLineCount(false) - 1;
            if(isSuffixContained) { characterCountWithPrefixSuffix += this.layer.getSuffixCount(); }

            if(characterCountWithPrefixSuffix == 0)
            {
                // 改行しか存在しない行
                var info = this.layer.getCharacterInfo(lineIndex, 0, this.isPlaceholderVisible);
                if(info != null)
                {
                    // "あ"のサイズを測る
                    var tempFontSize = this.layer.autoSize && this.lastAutoFontSize > 0 ? this.lastAutoFontSize : info.textInfo.fontSize;
                    var scaledFontSize = isSameFontSize ? scaledSameFontSize : UnitHelper.convert(tempFontSize, "pt", "mm") * this.scale;
                    var size = this.calcTextSize("あ", scaledFontSize, info.textInfo.fontId, info.textInfo.bold, info.textInfo.italic, true);
                    // この高さだけ送る
                    x -= size.width / 2;
                    array.push({
                        character : "",
                        lineIndex : lineIndex,
                        characterIndex : 0,
                        textInfo : info.textInfo,
                        x : x,
                        y : y,
                        width : size.width,
                        height : size.height,
                        fontSize : scaledFontSize,
                        letterWidth : info.textInfo.letterWidth,
                        renderLineIndex : renderLineIndex,
                        renderCharacterIndex : 0,
                        uuid : UuidHelper.getUuid(),
                        boundsBefore : new Rectangle(),
                        boundsAfter : new Rectangle()
                    });
                    x -= size.width * (this.layer.lineSpacing - 50) / 100;
                    maxWidthArray.push(size.width);
                    renderLineIndex++;
                }
            }
            else
            {
                for(var totalCharacterIndex = 0; totalCharacterIndex < characterCountWithPrefixSuffix; ++totalCharacterIndex)
                {
                    var info : { character : string, index : number, textInfo : TextInfo } | null = null;
                    var characterIndex = -1;
                    if(isPrefixContained && totalCharacterIndex < this.layer.getPrefixCount())
                    {
                        info = this.layer.getPrefixCharacterInfo(totalCharacterIndex);
                    }
                    else if(isSuffixContained && totalCharacterIndex >= characterCountWithPrefixSuffix - this.layer.getSuffixCount())
                    {
                        info = this.layer.getSuffixCharacterInfo(totalCharacterIndex - (characterCountWithPrefixSuffix - this.layer.getSuffixCount()));
                    }
                    else
                    {
                        characterIndex = isPrefixContained ? totalCharacterIndex - this.layer.getPrefixCount() : totalCharacterIndex;
                        info = this.layer.getCharacterInfo(lineIndex, characterIndex, this.isPlaceholderVisible);
                    }
                    if(info != null)
                    {
                        // この文字の大きさを測る
                        var tempFontSize = this.layer.autoSize && this.lastAutoFontSize > 0 ? this.lastAutoFontSize : info.textInfo.fontSize;
                        var scaledFontSize = isSameFontSize ? scaledSameFontSize : UnitHelper.convert(tempFontSize, "pt", "mm") * this.scale;
                        var isHankaku = StringHelper.isHankaku(info.character);
                        var size = this.calcTextSize(info.character, scaledFontSize, info.textInfo.fontId, info.textInfo.bold, info.textInfo.italic, !info.textInfo.isHorizontalInVertical);
                        // 高さをこの文字の設定に変更
                        size.height *= info.textInfo.letterWidth / 100;
                        if(isAutoNewLine)
                        {
                            if(y + size.height > (this.layer.y + this.layer.height) * this.scale + this.offsetY)
                            {
                                // 描画位置が枠を超えてしまうので改行
                                // 改行前に同じ行にいる文字のx座標を左方向にずらす ... 描画指定位置が上中央になるため
                                // 縦中横の文字格納
                                var horizontalArray = new Array();
                                for(var i = 0; i < numberInLine; ++i)
                                {
                                    var arrayIndex = array.length - 1 - i;
                                    if(arrayIndex >= 0)
                                    {
                                        if(array[arrayIndex].textInfo.isHorizontalInVertical)
                                        {
                                            // 縦中横
                                            horizontalArray.push(array[arrayIndex]);
                                        }
                                        else
                                        {
                                            if(horizontalArray.length > 0)
                                            {
                                                var horizontalWidth = horizontalArray[0].x + horizontalArray[0].width - horizontalArray[horizontalArray.length - 1].x;
                                                var horizontalHeight = 0;
                                                for(var horizontal of horizontalArray)
                                                {
                                                    horizontalHeight = Math.max(horizontalHeight, horizontal.height);
                                                }
                                                for(var horizontal of horizontalArray)
                                                {
                                                    horizontal.x -= maxWidth / 2 + horizontalWidth / 2;
                                                    horizontal.y += horizontalHeight;
                                                }
                                                horizontalArray = new Array();
                                            }
                                            array[arrayIndex].x -= maxWidth / 2;
                                        }
                                    }
                                }
                                if(horizontalArray.length > 0)
                                {
                                    var horizontalWidth = horizontalArray[0].x + horizontalArray[0].width - horizontalArray[horizontalArray.length - 1].x;
                                    var horizontalHeight = 0;
                                    for(var horizontal of horizontalArray)
                                    {
                                        horizontalHeight = Math.max(horizontalHeight, horizontal.height);
                                    }
                                    for(var horizontal of horizontalArray)
                                    {
                                        horizontal.x -= maxWidth / 2 + horizontalWidth / 2;
                                        horizontal.y += horizontalHeight;
                                    }
                                    horizontalArray = new Array();
                                }
                                // 行間に従って送る
                                x -= maxWidth * this.layer.lineSpacing / 100;
                                y = this.layer.y * this.scale + this.offsetY;
                                maxWidthArray.push(maxWidth);
                                renderLineIndex++;
                                maxWidth = 0;
                                numberInLine = 0;
                                renderCharacterIndex = 0;
                            }
                        }

                        array.push({
                            character : info.character,
                            lineIndex : lineIndex,
                            characterIndex : characterIndex,
                            textInfo : info.textInfo,
                            x : x,
                            y : y,
                            width : size.width,
                            height : size.height,
                            fontSize : scaledFontSize,
                            letterWidth : info.textInfo.letterWidth,
                            renderLineIndex : renderLineIndex,
                            renderCharacterIndex : renderCharacterIndex,
                            uuid : UuidHelper.getUuid(),
                            boundsBefore : new Rectangle(),
                            boundsAfter : new Rectangle()
                        });

                        if(info.textInfo.isHorizontalInVertical)
                        {
                            // この文字は縦中横
                            // 文字送り
                            x += size.width;
                            horizontalWidth += size.width;
                            maxHeight = Math.max(maxHeight, size.height);
                            // 次の文字を調べて縦中横が終わるか調べる
                            var isEndHorizontal = false;
                            if(characterIndex + 1 < characterCount)
                            {
                                var nextInfo = this.layer.getCharacterInfo(lineIndex, characterIndex + 1, this.isPlaceholderVisible);
                                isEndHorizontal = nextInfo != null && !nextInfo.textInfo.isHorizontalInVertical;
                            }
                            else
                            {
                                // 行の最終文字なら終了
                                isEndHorizontal = true;
                            }
                            if(isEndHorizontal)
                            {
                                // 縦中横が終了した
                                // x方向の文字送りを戻る
                                x -= horizontalWidth;
                                // y方向に文字を送る
                                y += maxHeight;
                                // 最大幅更新
                                maxWidth = Math.max(maxWidth, horizontalWidth);
                                horizontalWidth = 0;
                                maxHeight = 0;
                                if(this.layer.horizontalAlignment != 3)
                                {
                                    // 文字間を空ける *均等以外
                                    y += UnitHelper.convert(info.textInfo.letterSpacing, "pt", "mm") * this.scale;
                                }
                            }
                            else
                            {
                                // 字間を空ける
                                var spacing = UnitHelper.convert(info.textInfo.letterSpacing, "pt", "mm") * this.scale;
                                x += spacing;
                                horizontalWidth += spacing;
                            }
                        }
                        else
                        {
                            // 文字送り
                            y += size.height;
                            // 最大幅更新
                            maxWidth = Math.max(maxWidth, size.width);
                            if(this.layer.horizontalAlignment != 3)
                            {
                                // 文字間を空ける *均等以外
                                y += UnitHelper.convert(info.textInfo.letterSpacing, "pt", "mm") * this.scale;
                            }
                        }
                        numberInLine++;
                        renderCharacterIndex++;

                    }
                }
            }
            // 改行
            // 改行前に同じ行にいる文字のx座標を左方向にずらす ... 描画指定位置が上中央になるため
            // 縦中横の文字格納
            var horizontalArray = new Array();
            for(var i = 0; i < numberInLine; ++i)
            {
                var arrayIndex = array.length - 1 - i;
                if(arrayIndex >= 0)
                {
                    if(array[arrayIndex].textInfo.isHorizontalInVertical)
                    {
                        // 縦中横
                        horizontalArray.push(array[arrayIndex]);
                    }
                    else
                    {
                        if(horizontalArray.length > 0)
                        {
                            var horizontalWidth = horizontalArray[0].x + horizontalArray[0].width - horizontalArray[horizontalArray.length - 1].x;
                            var horizontalHeight = 0;
                            for(var horizontal of horizontalArray)
                            {
                                horizontalHeight = Math.max(horizontalHeight, horizontal.height);
                            }
                            for(var horizontal of horizontalArray)
                            {
                                horizontal.x -= maxWidth / 2 + horizontalWidth / 2;
                                horizontal.y += horizontalHeight;
                            }
                            horizontalArray = new Array();
                        }
                        array[arrayIndex].x -= maxWidth / 2;
                    }
                }
            }
            if(horizontalArray.length > 0)
            {
                var horizontalWidth = horizontalArray[0].x + horizontalArray[0].width - horizontalArray[horizontalArray.length - 1].x;
                var horizontalHeight = 0;
                for(var horizontal of horizontalArray)
                {
                    horizontalHeight = Math.max(horizontalHeight, horizontal.height);
                }
                for(var horizontal of horizontalArray)
                {
                    horizontal.x -= maxWidth / 2 + horizontalWidth / 2;
                    horizontal.y += horizontalHeight;
                }
                horizontalArray = new Array();
            }
            // 行間に従って送る
            x -= maxWidth * this.layer.lineSpacing / 100;
            y = this.layer.y * this.scale + this.offsetY;
            maxWidthArray.push(maxWidth);
            renderLineIndex++;
            maxWidth = 0;
            numberInLine = 0;
            renderCharacterIndex = 0;
        }

        // 縦書き用文字変換
        if(UserAgentHelper.getBrowser() == "safari" && !this.isRendering && array.length > 0)
        {
            for(var i = 0; i < array.length; ++i)
            {
                if(!array[i].textInfo.isHorizontalInVertical)
                {
                    if(StringHelper.isHankaku(array[i].character))
                    {
                        // nothing
                    }
                    else
                    {
                        array[i].character = StringHelper.toVerticalString(array[i].character);
                    }
                }
            }
        }

        // 垂直方向位置 *縦書きの場合は水平方向のプロパティを垂直方向に適用する
        if(this.layer.horizontalAlignment != 0)
        {
            // 左(=上)揃え以外
            var tempArray = new Array();
            for(var i = 0; i < array.length; ++i)
            {
                var item = array[i];

                // 一時配列にアイテムを加える
                tempArray.push(item);

                // 行の最後かどうかしらべる
                var isLastInLine = false;
                if(i == array.length - 1)
                {
                    // 最後のアイテム
                    isLastInLine = true;
                }
                else
                {
                    // 次のアイテムの行番号が異なる
                    isLastInLine = item.renderLineIndex != array[i + 1].renderLineIndex;
                }

                if(isLastInLine)
                {
                    // 行の最後なら垂直揃えをする
                    // 行の長さ = (行最後のアイテムのy座標 + 高さ) - (行最初のアイテムのy座標)
                    var lineWidth = tempArray[tempArray.length - 1].y + tempArray[tempArray.length - 1].height - tempArray[0].y;

                    if(this.layer.horizontalAlignment == 1 || this.layer.horizontalAlignment == 2)
                    {
                        // 中央/右(=下)揃えは同じ値だけy座標をずらす
                        var dy = 0;
                        if(this.layer.horizontalAlignment == 1)
                        {
                            // 中央揃え (レイヤーの高さ - 行の長さ) / 2
                            dy = (this.layer.height * this.scale - lineWidth) / 2;
                        }
                        else if(this.layer.horizontalAlignment == 2)
                        {
                            // 右(=下)揃え レイヤーの高さ - 行の長さ
                            dy = this.layer.height * this.scale - lineWidth;
                        }
                        for(var tempItem of tempArray)
                        {
                            tempItem.y += dy;
                        }
                    }
                    else if(this.layer.horizontalAlignment == 3)
                    {
                        // 均等揃えは字間を再設定する
                        // 文字数をカウントする。ただし半角英数記号は並びあっている限りは一文字扱いする
                        // "abc "で1文字
                        var textCount = 0;
                        for(var t = 0; t < tempArray.length; ++t)
                        {
                            var item = tempArray[t];
                            if(item.character.match(/^[\x20-\x7e]*$/) != null && item.character != " ")
                            {
                                // 半角英数記号にマッチング
                                // 末尾 or 次の文字が半角英数記号以外なら文字としてカウント
                                if(t == tempArray.length - 1 || (t < tempArray.length - 1 && !(tempArray[t + 1].character.match(/^[\x20-\x7e]*$/) != null && tempArray[t + 1].character != " ")))
                                {
                                    textCount++;
                                }
                            }
                            else if(item.character == " ")
                            {
                                // 半角スペースにマッチング
                                // 最初 or 直前の文字が半角英数記号以外なら文字としてカウント
                                if(t == 0 || (t > 1 && !(tempArray[t - 1].character.match(/^[\x20-\x7e]*$/) != null && tempArray[t - 1].character != " ")))
                                {
                                    textCount++;
                                }
                            }
                            else
                            {
                                // 文字カウント
                                textCount++;
                            }
                        }

                        if(textCount > 1)
                        {
                            // 2文字以上のみ均等割を行う
                            var spacing = (this.layer.height * this.scale - lineWidth) / (textCount - 1);
                            // 字間は0以上に補正
                            if(spacing < 0) { spacing = 0; }
                            // 字間を設定していく
                            var dy = 0;
                            for(var t = 0; t < tempArray.length; ++t)
                            {
                                var item = tempArray[t];
                                item.y+= dy;

                                if(item.character.match(/^[\x20-\x7e]*$/) != null && item.character != " ")
                                {
                                    // 半角英数記号にマッチング
                                    if(t < tempArray.length - 1 && tempArray[t + 1].character.match(/^[\x20-\x7e]*$/) == null)
                                    {
                                        // 次の文字が半角英数記号以外
                                        dy += spacing;
                                    }
                                }
                                else
                                {
                                    dy += spacing;
                                }
                            }
                        }
                    }

                    // 一時配列クリア
                    tempArray = new Array();
                }
            }
        }

        // 水平方向位置 *縦書きの場合は垂直方向のプロパティを水平方向に適用する
        if(this.layer.verticalAlignment != 0)
        {
            // 上(=右)揃え以外
            // 全文字の一番右の座標・一番左の座標を求める
            var minX = 0;
            var maxX = 0;
            for(var i = 0; i < array.length; ++i)
            {
                var item = array[i];
                if(i == 0 || item.x < minX) { minX = item.x; }
                if(i == 0 || item.x + item.width > maxX) { maxX = item.x + item.width; }
            }
            // 文字全体の幅
            var allWidth = maxX - minX;
            // 同じ値だけx座標をずらす
            var dx = 0;
            if(this.layer.verticalAlignment == 1)
            {
                // 中央揃え (レイヤーの幅 - 文字全体の幅) / 2;
                dx = (this.layer.width * this.scale - allWidth) / 2;
            }
            else if(this.layer.verticalAlignment == 2)
            {
                // 下(=左)揃え (レイヤーの幅 - 文字全体の高さ)
                dx = this.layer.width * this.scale - allWidth;
            }
            for(var item of array)
            {
                item.x -= dx;
            }
        }

        // 判定領域設
        for(var i = 0; i < array.length; ++i)
        {
            // 行の最後か?
            var isLastInLine = i == array.length - 1 ? true : array[i].renderLineIndex != array[i + 1].renderLineIndex;
            // 最終行か?
            var isLastLine = array[i].renderLineIndex == array[array.length - 1].renderLineIndex;
            // 所属行の最大幅
            var maxWidth = maxWidthArray[array[i].renderLineIndex];

            var bounds = new Rectangle();

            if(array[i].textInfo.isHorizontalInVertical)
            {
                // 縦中横
                // 計算の単純のため、テキストの周りを囲むだけ
                bounds.x = array[i].x;
                bounds.y = array[i].y - array[i].height;
                bounds.width = array[i].width;
                bounds.height = array[i].height;

                // 設定
                var beforeWidth = Math.max((array[i].x + array[i].width / 2) - bounds.x, 0);
                var afterWidth = Math.max(bounds.width - beforeWidth, 0);
                array[i].boundsBefore = new Rectangle(bounds.x, bounds.y, beforeWidth, bounds.height);
                array[i].boundsAfter = new Rectangle(bounds.x + beforeWidth, bounds.y, afterWidth, bounds.height);
            }
            else
            {
                // 縦中横以外

                // rightは最初の行なら右端、それ以外は文字の右端
                var r = array[i].renderLineIndex == 0 ? this.layer.x * this.scale + this.offsetX + this.layer.width * this.scale : array[i].x + array[i].width;
                // y座標は最初の文字なら上端、それ以外は文字の上端
                bounds.y = array[i].renderCharacterIndex == 0 ? this.layer.y * this.scale + this.offsetY : array[i].y;
                // 高さは次の文字のy座標からy座標を引いた値 ただし最終文字の場合はレイヤーの下端から引く
                bounds.height = (isLastInLine ? this.layer.y * this.scale + this.offsetY + this.layer.height * this.scale : array[i + 1].y) - bounds.y;
                if(i < array.length - 1 && array[i + 1].textInfo.isHorizontalInVertical)
                {
                    // 次の文字が縦中横の場合は次の文字の高さを引く
                    bounds.height -= array[i + 1].height;
                }
                // leftは文字の左端から行間を引く
                var l = array[i].x - array[i].width * (this.layer.lineSpacing - 100) / 100;
                // 最終行でこの値が左端より右だった場合は左端にする
                if(isLastLine && this.layer.x * this.scale + this.offsetX < l) { l = this.layer.x * this.scale + this.offsetX; }
                bounds.x = l;
                bounds.width = r - l;

                // 幅は最低限文字幅分を確保
                if(bounds.width < array[i].width) { bounds.width = array[i].width; }
                // 高さは最低限文字高さ分を確保
                if(bounds.height < array[i].height) { bounds.height = array[i].height; }

                // 設定
                var beforeHeight = Math.max((array[i].y + array[i].height / 2) - bounds.y, 0);
                var afterHeight = Math.max(bounds.height - beforeHeight, 0);
                array[i].boundsBefore = new Rectangle(bounds.x, bounds.y, bounds.width, beforeHeight);
                array[i].boundsAfter = new Rectangle(bounds.x, bounds.y + beforeHeight, bounds.width, afterHeight);
            }
        }

        return array;
    }

    // 下線配列
    private get underlineArray() : Array<{
        x : number,                     // x座標(view)
        y : number,                     // y座標(view)
        width : number,                 // 幅(view)
        height : number,                // 高さ(view)
        color : string,                 // 色(hex)
        uuid : string                   // UUID
    }>
    {
        var array = new Array();

        var renderLineIndex = 0;
        var renderCharacterIndex = 0;
        var tempArray = new Array();
        for(var i = 0; i < this.characterInfoArray.length; ++i)
        {
            var info = this.characterInfoArray[i];

            // レンダリングのための位置調整を元に戻す
            if(this.isRendering && this.layer.textOrientation == 1)
            {
                if(!info.textInfo.isHorizontalInVertical)
                {
                    info.x += info.width / 2;
                    if(StringHelper.isHankaku(info.character))
                    {
                        // nothing
                    }
                    else
                    {
                        info.y += -info.height / 10 * 9;
                    }
                }
            }

            // 文字情報を追加
            tempArray.push(info);
            var isLastInLine = i == this.characterInfoArray.length - 1 || this.characterInfoArray[i + 1].renderLineIndex != info.renderLineIndex;
            if(isLastInLine)
            {
                // この文字が行終了
                if(this.layer.textOrientation == 1)
                {
                    // 縦書き *傍線を右に引く

                    // 最大となるテキストの幅を求める
                    var maxWidth = 0;
                    for(var tempInfo of tempArray)
                    {
                        if(tempInfo.textInfo.isHorizontalInVertical)
                        {
                            continue;
                        }
                        maxWidth = Math.max(tempInfo.width, maxWidth);
                    }
                    // 傍線の幅
                    var underlineW = maxWidth * PlainTextLayerDrawer.UNDERLINE_HEIGHT_FROM_CHARACTER_HEIGHT;
                    // 傍線の情報を追加していく
                    for(var t = 0; t < tempArray.length; ++t)
                    {
                        var tempInfo = tempArray[t];
                        // 縦中横には傍線が引けない
                        if(tempInfo.textInfo.isHorizontalInVertical)
                        {
                            continue;
                        }
                        if(tempInfo.character != "" && tempInfo.textInfo.underline)
                        {
                            // 次の文字にアンダーラインがあるか？
                            var isNextUnderline = false;
                            if(t < tempArray.length - 1)
                            {
                                var nextTemp = tempArray[t + 1];
                                isNextUnderline = nextTemp.textInfo.underline && !nextTemp.textInfo.isHorizontalInVertical;
                            }
                            // 下線を示す矩形
                            var underlineX = tempInfo.x + maxWidth / 2;
                            var underlineY = tempInfo.y;
                            var underlineH = tempInfo.height;
                            if(isNextUnderline)
                            {
                                underlineH = tempArray[t + 1].y - tempInfo.y;
                            }
                            var underlineColor = tempInfo.textInfo.textColor.hex;
                            array.push({ x : underlineX, y : underlineY, width : underlineW, height : underlineH, color : underlineColor, uuid : UuidHelper.getUuid() });
                        }
                    }
                }
                else
                {
                    // 横書き

                    // 最大となるテキストの高さを求める
                    var maxHeight = 0;
                    for(var tempInfo of tempArray)
                    {
                        maxHeight = Math.max(tempInfo.height, maxHeight);
                    }
                    // 下線の高さ
                    var underlineHeight = maxHeight * PlainTextLayerDrawer.UNDERLINE_HEIGHT_FROM_CHARACTER_HEIGHT;
                    // 下線の情報を追加していく
                    for(var t = 0; t < tempArray.length; ++t)
                    {
                        var tempInfo = tempArray[t];
                        if(tempInfo.character != "" && tempInfo.textInfo.underline)
                        {
                            // 次の文字にアンダーラインがあるか？
                            var isNextUnderline = false;
                            if(t < tempArray.length - 1)
                            {
                                var nextTemp = tempArray[t + 1];
                                isNextUnderline = nextTemp.textInfo.underline;
                            }
                            // 下線を示す矩形
                            var underlineX = tempInfo.x;
                            var underlineY = tempInfo.y + maxHeight * PlainTextLayerDrawer.UNDERLINE_SPACING_FROM_CHARACTER_HEIGHT;
                            var underlineWidth = tempInfo.width;
                            if(isNextUnderline)
                            {
                                underlineWidth = tempArray[t + 1].x - tempInfo.x;
                            }
                            var underlineColor = tempInfo.textInfo.textColor.hex;
                            array.push({ x : underlineX, y : underlineY, width : underlineWidth, height : underlineHeight, color : underlineColor, uuid : UuidHelper.getUuid() });
                        }
                    }
                }

                tempArray = new Array();
            }
        }

        return array;
    }

    // positionを元にcharacterInfoを得る
    // characterInfo
    // isFirstInLine : [行の先頭かどうか]
    private getCharacterInfoFromPosition(position)
    {
        var indexPair = this.layer.getLineAndCharacterIndexFromPosition(position);
        var array = this.characterInfoArray;
        for(var info of array)
        {
            if(info.lineIndex == indexPair.lineIndex && info.characterIndex == indexPair.characterIndex)
            {
                return { characterInfo : info, isFirstInLine : indexPair.isFirstInLine };
            }
        }
        return null;
    }

    // キャレットを表示するか
    private get charetVisible()
    {
        // レンダリング中表示しない
        if(this.isRendering) { return false; }
        // エディット対象でなければ表示しない
        if(!this.isInEditor) { return false; }

        return this.layer.inEdit && this.layer.startPosition == this.layer.endPosition;
    }

    // キャレット位置
    // x1, y1, x2, y2
    private getCharetPos()
    {
        var info = this.getCharacterInfoFromPosition(this.layer.startPosition);
        if(info == null) { return { x1 : 0, y1 : 0, x2 : 0, y2 : 0}; }

        var x1 = 0;
        var y1 = 0;
        var x2 = 0;
        var y2 = 0;
        if(this.layer.textOrientation == 1 && !info.characterInfo.textInfo.isHorizontalInVertical)
        {
            // 縦書き
            if(info.isFirstInLine)
            {
                x1 = info.characterInfo.x - info.characterInfo.width / 2;
                y1 = info.characterInfo.y;
                x2 = x1 + info.characterInfo.width;
                y2 = y1;
            }
            else
            {
                x1 = info.characterInfo.x - info.characterInfo.width / 2;
                y1 = info.characterInfo.y + info.characterInfo.height;
                x2 = x1 + info.characterInfo.width;
                y2 = y1;
            }

            if(MathHelper.equals(y1, this.layer.y * this.scale + this.offsetY))
            {
                // キャレットがバウンディングボックスに隠れるので少しずらす
                y1 += 4;
                y2 = y1;
            }
            else if(MathHelper.equals(y1, this.layer.y * this.scale + this.offsetY + this.layer.height * this.scale))
            {
                // キャレットがバウンディングボックスに隠れるので少しずらす
                y1 -= 4;
                y2 = y1;
            }
        }
        else
        {
            // 横書き
            if(info.isFirstInLine)
            {
                x1 = info.characterInfo.x;
                y1 = info.characterInfo.y - info.characterInfo.height;
                x2 = x1;
                y2 = y1 + info.characterInfo.height;
            }
            else
            {
                x1 = info.characterInfo.x + info.characterInfo.width;
                y1 = info.characterInfo.y - info.characterInfo.height;
                x2 = x1;
                y2 = y1 + info.characterInfo.height;
            }

            if(MathHelper.equals(x1, this.layer.x * this.scale + this.offsetX))
            {
                // キャレットがバウンディングボックスに隠れるので少しずらす
                x1 += 4;
                x2 = x1;
            }
            else if(MathHelper.equals(x1, this.layer.x * this.scale + this.offsetX + this.layer.width * this.scale))
            {
                // キャレットがバウンディングボックスに隠れるので少しずらす
                x1 -= 4;
                x2 = x1;
            }
        }
        return { x1 : x1, y1 : y1, x2 : x2, y2 : y2 };
    }

    // 選択を表示するか
    private get selectionVisible()
    {
        // レンダリング中表示しない
        if(this.isRendering) { return false; }
        // エディット対象でなければ表示しない
        if(!this.isInEditor) { return false; }

        return this.layer.inEdit && this.layer.startPosition != this.layer.endPosition;
    }

    // 選択領域
    private get selectionRectArray()
    {
        var start = Math.min(this.layer.startPosition, this.layer.endPosition);
        var end = Math.max(this.layer.startPosition, this.layer.endPosition);
        var rectArray = new Array();
        for(var i = start + 1; i <= end; ++i)
        {
            var info = this.getCharacterInfoFromPosition(i);
            if(info != null)
            {
                if(this.layer.textOrientation == 1 && !info.characterInfo.textInfo.isHorizontalInVertical)
                {
                    // 縦書き
                    rectArray.push({
                        x : info.characterInfo.x - info.characterInfo.width / 2,
                        y : info.characterInfo.y,
                        width : info.characterInfo.width,
                        height : info.characterInfo.height
                    });
                }
                else
                {
                    // 横書き
                    rectArray.push({
                        x : info.characterInfo.x,
                        y : info.characterInfo.y - info.characterInfo.height,
                        width : info.characterInfo.width,
                        height : info.characterInfo.height
                    });
                }
            }
        }

        return rectArray;
    }

    private getCharacterStyle(characterInfo)
    {
        var isHankaku = StringHelper.isHankaku(characterInfo.character);
        var isVertical = this.layer.textOrientation == 1 && !characterInfo.textInfo.isHorizontalInVertical;
        var style = {
            "font-family" : this.getFontFamily(characterInfo.textInfo, isHankaku, isVertical),
            "font-size" : characterInfo.fontSize,
            "font-weight" : this.getFontWeight(characterInfo.textInfo),
            "font-style" : this.getFontStyle(characterInfo.textInfo, isHankaku),
            "fill" : characterInfo.textInfo.textColor.hex
        };
        if(isVertical)
        {
            // 縦書き *縦中横の場合は除く
            style["-webkit-writing-mode"] = "vertical-rl";
            style["-ms-writing-mode"] = "tb-rl";
            style["writing-mode"] = "vertical-rl";
        }
        return style;
    }

    private getWritingMode(characterInfo)
    {
        var isVertical = this.layer.textOrientation == 1 && !characterInfo.textInfo.isHorizontalInVertical;
        return isVertical ? "tb" : "lr";
    }

    private isVisibleOutline(characterInfo)
    {
        return characterInfo.textInfo.isOutline;
    }

    private getOutlineStyle(characterInfo)
    {
        var isHankaku = StringHelper.isHankaku(characterInfo.character);
        var isVertical = this.layer.textOrientation == 1 && !characterInfo.textInfo.isHorizontalInVertical;
        var outlineThickness = characterInfo.fontSize * characterInfo.textInfo.outlineThickness / 750;
        var style = {
            "font-family" : this.getFontFamily(characterInfo.textInfo, isHankaku, isVertical),
            "font-size" : characterInfo.fontSize,
            "font-weight" : this.getFontWeight(characterInfo.textInfo),
            "font-style" : this.getFontStyle(characterInfo.textInfo, isHankaku),
            "fill" : "none",
            "stroke" : characterInfo.textInfo.outlineColor.hex,
            "stroke-width" : this.alternativeOutlineThickness(characterInfo) + outlineThickness,
            "stroke-linejoin" : "round",
            "opacity" : MathHelper.clamp(characterInfo.textInfo.outlineIntensity / 100, 0, 1)
        };
        if(isVertical)
        {
            // 縦書き *縦中横の場合は除く
            style["-webkit-writing-mode"] = "vertical-rl";
            style["-ms-writing-mode"] = "tb-rl";
            style["writing-mode"] = "vertical-rl";
        }
        return style;
    }

    private isVisibleAlternativeOutline(characterInfo) {
        return characterInfo.textInfo.bold && FontManager.UseAlternativeOutlineToBold(characterInfo.textInfo.fontId);
    }

    private alternativeOutlineThickness(characterInfo) {
        return this.isVisibleAlternativeOutline(characterInfo) ? characterInfo.fontSize * 24 / 750 : 0;
    }

    private alternativeOutlineStyle(characterInfo) {
        var isHankaku = StringHelper.isHankaku(characterInfo.character);
        var isVertical = this.layer.textOrientation == 1 && !characterInfo.textInfo.isHorizontalInVertical;
        var style = {
            "font-family": this.getFontFamily(characterInfo.textInfo, isHankaku, isVertical),
            "font-size" : characterInfo.fontSize,
            "font-weight" : this.getFontWeight(characterInfo.textInfo),
            "font-style" : this.getFontStyle(characterInfo.textInfo, isHankaku),
            "fill" : "none",
            "stroke" : characterInfo.textInfo.textColor.hex,
            "stroke-width" : this.alternativeOutlineThickness(characterInfo),
            "stroke-linejoin" : "round"
        };

        if(isVertical)
        {
            // 縦書き *縦中横の場合は除く
            style["-webkit-writing-mode"] = "vertical-rl";
            style["-ms-writing-mode"] = "tb-rl";
            style["writing-mode"] = "vertical-rl";
        }

        return style;
    }

    private isShadow(characterInfo)
    {
        return characterInfo.textInfo.isShadow;
    }

    private shadowBlurFilterId(characterInfo)
    {
        return "shadowBlurFilterId_" + characterInfo.uuid;
    }

    private blurFilterUrl(characterInfo)
    {
        return "url(#" + this.shadowBlurFilterId(characterInfo) + ")";
    }

    private getTextShadowDiviation(characterInfo)
    {
        // 出力時は影を弱くする
        var path = this.$router.currentRoute.path;
        var fix = path == "/PrintSetting" && this.isRendering ? 0.2 : 1;
        return characterInfo.textInfo.shadowBlur / 10 * fix;
    }

    private getShadowPosition(characterInfo)
    {
        // 影
        var distance = characterInfo.fontSize * 2 * characterInfo.textInfo.shadowDistance / 100;
        var radian = characterInfo.textInfo.shadowRotate * Math.PI / 180;
        var xDistance = distance * Math.cos(radian);
        var yDistance = distance * Math.sin(radian);
        return { x : characterInfo.x + xDistance, y : characterInfo.y + yDistance }
    }

    private getShadowStyle(characterInfo)
    {
        var shadowColorR = characterInfo.textInfo.shadowColor.r;
        var shadowColorG = characterInfo.textInfo.shadowColor.g;
        var shadowColorB = characterInfo.textInfo.shadowColor.b;
        var shadowColorA = MathHelper.clamp(characterInfo.textInfo.shadowIntensity / 100, 0, 1);
        var shadowColorRgba = "rgba(" + shadowColorR + "," + shadowColorG + "," + shadowColorB + "," + shadowColorA + ")";

        var isHankaku = StringHelper.isHankaku(characterInfo.character);
        var isVertical = this.layer.textOrientation == 1 && !characterInfo.textInfo.isHorizontalInVertical;
        var style = {
            "font-family" : this.getFontFamily(characterInfo.textInfo, isHankaku, isVertical),
            "font-size" : characterInfo.fontSize,
            "font-weight" : this.getFontWeight(characterInfo.textInfo),
            "font-style" : this.getFontStyle(characterInfo.textInfo, isHankaku),
            "fill" : shadowColorRgba
        };
        if(isVertical)
        {
            // 縦書き *縦中横の場合は除く
            style["-webkit-writing-mode"] = "vertical-rl";
            style["-ms-writing-mode"] = "tb-rl";
            style["writing-mode"] = "vertical-rl";
        }
        return style;
    }

    private getFontFamily(textInfo, isHankaku = false, isVertical = false) : string
    {
        var fontManager : FontManager = this.$store.getters.fontManager;
        // 直接印刷ではクライアントで処理するのでサーバー用のフォントになると困る
        return fontManager.getFontFamilyName(textInfo.fontId, isHankaku, this.isRendering && !this.isRenderingOnClient, isVertical, this.isRenderingOnClient);
    }

    private getFontWeight(textInfo) : string
    {
        var fontManager : FontManager = this.$store.getters.fontManager;
        var font = fontManager.getFontFamilyById(textInfo.fontId);
        // 太字の代わりに縁取りを使用する場合はboldをfalseとして扱う
        let bold = textInfo.bold;
        if(FontManager.UseAlternativeOutlineToBold(textInfo.fontId)) bold = false;
        // ウェイトがない場合はボールド設定を返す
        if(font.weight == null) { return bold ? "bold" : "normal"; }
        // レンダリング中はウェイト数値が無効なので、700以上かボールド設定ならボールド、それ以外ならnormalを返す
        if(this.isRendering && !this.isRenderingOnClient) { return (font.weight >= 700 || bold) ? "bold" : "normal"; }
        // ボールド設定がない場合はウェイトを返す
        if(!bold) { return font.weight.toString(); }
        // 700 = bold なので、weight値を使い、それ以下のときはboldを指定する。
        return font.weight > 700 ? font.weight.toString() : "bold";
    }

    private getFontStyle(textInfo, isHankaku = false) : string
    {
        // var fontManager : FontManager = this.$store.getters.fontManager;
        // return textInfo.italic && fontManager.canItalic(textInfo.fontId, isHankaku) ? "italic" : "normal";
        return textInfo.italic ? "italic" : "normal";
    }

    private get transform() : string
    {
        var transform = "";

        // オフセット
        var offsetX = this.offsetX + this.layer.x * this.scale;
        var offsetY = this.offsetY + this.layer.y * this.scale;
        transform += "translate(" + offsetX + " " + offsetY + "),";

        // 回転を適用する
        transform += "rotate(" + this.layer.rotate + "),";

        // オフセット
        transform += "translate(" + -offsetX + " " + -offsetY + ")";

        return transform;
    }

    private getCharacterTransform(characterInfo) : string
    {
        var characterTransform = "";

        // レイヤーの変形
        characterTransform += this.transform + ",";

        // 文字の変形
        characterTransform += "translate(" + characterInfo.x + " " + characterInfo.y + "),";

        if(this.layer.textOrientation == 1)
        {
            // 縦書き
            characterTransform += "scale(" + "1 " + (characterInfo.letterWidth / 100) + "),";
            // if(this.isRendering && !characterInfo.textInfo.isHorizontalInVertical)
            // {
            //     // レンダリング位置調整
            //     //characterTransform += "translate(" + (-characterInfo.width / 10 * 3) + " " + 0 + "),";

            //     if(StringHelper.isHankaku(characterInfo.character))
            //     {
            //         // 半角文字は90度回転
            //         //characterTransform += "rotate(" + 90 + "),";
            //     }
            //     else
            //     {
            //         //characterTransform += "translate(" + 0 + " " + characterInfo.height / 10 * 9 + "),";
            //     }
            // }

            // Safariで縦書きのみ位置補正
            if(!this.isRendering && UserAgentHelper.getBrowser() == "safari")
            {
                if(!StringHelper.isHankaku(characterInfo.character))
                {
                    characterTransform += "translate(" + 0 + " " + -characterInfo.height / 4 + "),";
                }
            }

            // IEで位置補正
            if(!this.isRendering && UserAgentHelper.getBrowser() == "ie")
            {
                if(!StringHelper.isHankaku(characterInfo.character))
                {
                    characterTransform += "translate(" + -characterInfo.width / 4 + " " + 0 + "),";
                }
            }
        }
        else
        {
            // 横書き
            characterTransform += "scale(" + (characterInfo.letterWidth / 100) + " 1),";
        }

        characterTransform += "translate(" + -characterInfo.x + " " + -characterInfo.y + ")";

        return characterTransform;
    }

    // テキスト領域判定
    private onTextBounds(info, isAfter : boolean)
    {
        DebugHelper.trace("on")
        // 選択中のテキスト位置を保持
        this.layer.selectedLineIndex = info.lineIndex;
        this.layer.selectedCharacterIndex = info.characterIndex;
        this.layer.isAfterSelected = isAfter;
    }

    private calcTextSize(str : string, fontSize : number, fontId : string = "", isBold : boolean = false, isItalic : boolean = false, isVertical : boolean = false)
    {
        // const _id = `${str},${fontSize},${fontId},${isBold},${isItalic},${isVertical}`;
        // if (dpTextSize.hasOwnProperty(_id)) {
        //     return dpTextSize[_id];
        // }

        var isHankaku = StringHelper.isHankaku(str);

        // fontSize -> pt
        var fontSizePt = UnitHelper.convert(fontSize / this.scale, "mm", "pt");
        var fontManager : FontManager = this.$store.getters.fontManager;
        var font = fontManager.getFontFamilyById(fontId);

        // fontFamily
        var fontFamily = fontManager.getFontFamilyName(fontId, isHankaku, false, isVertical);

        // weight
        var weight = "normal";
        if(font.weight == null)
        {
            // ウェイトがない場合はボールド設定を返す
            weight = isBold ? "bold" : "normal";
        }
        else
        {
            // ウェイトがある場合
            if(isBold)
            {
                weight = font.weight > 700 ? font.weight.toString() : "bold";
            }
            else
            {
                weight = font.weight.toString();
            }
        }

        // style
        var style = isItalic ? "italic" : "normal";

        var ptSize = StringHelper.calcTextSizeOnSVGPt(str, fontSizePt, fontFamily, weight, style, isVertical);

        var width = UnitHelper.convert(ptSize.width, "pt", "mm") * this.scale;
        var height = UnitHelper.convert(ptSize.height, "pt", "mm") * this.scale;

        const size = { width, height };
        // dpTextSize[_id] = size;
        return size;
    }
}
